<h4 class="text-center mb-0" i18n="@@verifyEmail.title">Please Verify Your Email</h4>

<div class="verify-email mt-3" i18n="@@verifyEmail.info2">Please verify your email by clicking on the link that we have sent you. After email is verified you will be automatically redirected to the application.</div>
<div class="text-end fst-italic mt-2" i18n="@@verifyEmail.thankYou">Thank you.</div>
